import { Modal, Button } from "antd";
import React from "react";

const RedirectModal = ({ open, setOpen, handleOk }) => {
  const handleCancel = () => {
    setOpen(false);
  };

  return (
    <div>
      <Modal
        centered
        open={open}
        // title="Redirecting to Browser"
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[
          <Button
            key="submit"
            type="primary"
            onClick={handleOk}
            variant="solid"
            style={{ width: "100%", background: "#00BF63", fontWeight: "bold" }}
            size="large"
          >
            Continue Order
          </Button>,
        ]}
      >
        <p>
          We can’t detect your location. We’ll be redirecting you to a browser.
        </p>
      </Modal>
    </div>
  );
};

export default RedirectModal;
